"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const INCRBY = require("./INCRBY");
const INFO = require("./INFO");
const INITBYDIM = require("./INITBYDIM");
const INITBYPROB = require("./INITBYPROB");
const MERGE = require("./MERGE");
const QUERY = require("./QUERY");
exports.default = {
    INCRBY,
    incrBy: INCRBY,
    INFO,
    info: INFO,
    INITBYDIM,
    initByDim: INITBYDIM,
    INITBYPROB,
    initByProb: INITBYPROB,
    MERGE,
    merge: MERGE,
    QUERY,
    query: QUERY
};
